fragment StoryPreviewFragment on story_Entry {
  title
  slug
  uri
  readTime
  image: previewImage {
    url
    title
  }
  categories: storiesCategories {
    uri
    title
  }
}
